import { render, staticRenderFns } from "./winpointsSetting.vue?vue&type=template&id=4e880d2f&scoped=true&"
import script from "./winpointsSetting.vue?vue&type=script&lang=js&"
export * from "./winpointsSetting.vue?vue&type=script&lang=js&"
import style0 from "./winpointsSetting.vue?vue&type=style&index=0&id=4e880d2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e880d2f",
  null
  
)

export default component.exports